/**
 * The selected campus, remembered across pages and reloads.
 *
 * ⚠ IT IS A HINT, NOT A PERMISSION. The server decides what this caller may see: a campus-level
 * role's institution comes from their token and this header is ignored entirely for them. Anything
 * written here by a curious user is either already permitted or already refused — which is why it
 * can live in localStorage without being a security question.
 */

const KEY = 'eduvora.campus';

/** The sentinel for a deliberate trust-wide read. ⚠ Distinct from "nothing chosen". */
export const ALL_CAMPUSES = 'all';

export function getCampus(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setCampus(id: string | null): void {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.setItem(KEY, ALL_CAMPUSES);
  } catch { /* private browsing — the request simply goes unscoped, as it does today */ }
}

/**
 * The header every API call carries.
 *
 * ⚠ ABSENT WHEN NOTHING HAS BEEN CHOSEN, rather than sent as "all". The server distinguishes a
 * deliberate trust-wide read from a request that never chose, and collapsing the two here would
 * throw away the only signal that says which of the 217 unscoped queries are running by accident.
 */
export function campusHeader(): Record<string, string> {
  const c = getCampus();
  return c ? { 'X-Eduvora-Institution': c } : {};
}
